import Link from "next/link";
import styles from "./ContentThroughSection.module.scss";
import { motion } from "framer-motion";

type ContentThroughSectionProps = {
  children: React.ReactNode;
};

export const ContentThroughSection = ({
  children = <BlogPostsDefault />,
}: ContentThroughSectionProps) => {
  return (
    <div className={styles.section}>
      <div className={styles.container}>{children}</div>
    </div>
  );
};

const BlogPostsDefault = () => (
  <>
    <motion.div
      className={styles.title}
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.3,
        type: "spring",
        stiffness: 400,
        damping: 40,
        mass: 1,
      }}
    >
      Get deals on books, courses, software.
      <br />
      All profits go to charities.
    </motion.div>
    <Link className={styles.ctaButton} href="/?from=through-section">
      Find out more.
    </Link>
  </>
);
